goog.provide("shadow.js.shim.module$xhr2");
goog.provide("module$shadow_js_shim_module$xhr2");
shadow.js.shim.module$xhr2 = require("xhr2");
module$shadow_js_shim_module$xhr2.default = shadow.js.shim.module$xhr2;
